import { render } from "./lockscreen.vue?vue&type=template&id=370b5f6b"
import script from "./lockscreen.vue?vue&type=script&lang=js"
export * from "./lockscreen.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__